<template lang="pug">
el-dialog(title="更新密码" :visible="visible" :before-close="hide")
    el-form(:model="form" :rules="updateRules" ref="form")
        el-form-item(label="当前密码" prop="current" label-width="120px")
            el-input(type="password" v-model="form.current")
        el-form-item(label="新密码" prop="password" label-width="120px")
            el-input(type="password" v-model="form.password")
        el-form-item(label="确认新密码" prop="confirmPass" label-width="120px")
            el-input(type="password" v-model="form.confirmPass")
    .dialog-footer(slot="footer")
        el-button(@click="hide") 取 消
        el-button(type="primary", @click="submit", :loading="loading") 确 定
</template>

<script>
import { updateUserAPI } from "@/services";
const defaultForm = {
    current: "",
    password: "",
    confirmPass: ""
};
export default {
    name: "userPasswordUpdateFrom",
    props: ["visible", "editing"],
    data() {
        const validatePassSecure = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.form.confirmPass !== "") {
                    this.$refs.form.validateField("confirmPass");
                }
                callback();
            }
        };
        const validatePassConfirm = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.form.password) {
                callback(new Error("两次输入密码不一致"));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            form: Object.assign({}, defaultForm),
            updateRules: {
                current: [
                    {
                        required: true,
                        message: "请输入当前密码",
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        min: 8,
                        max: 64,
                        message: "密码长度不得小于8",
                        trigger: "blur"
                    },
                    {
                        required: true,
                        validator: validatePassSecure,
                        trigger: "blur"
                    }
                ],
                confirmPass: [
                    {
                        required: true,
                        validator: validatePassConfirm,
                        trigger: "change"
                    }
                ]
            }
        };
    },
    methods: {
        /**
         * Backend Service API Func Wrapper
         */
        async updateUser() {
            this.loading = true;
            try {
                const res = await updateUserAPI(
                    this.editing.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 200) {
                    this.$message.success("保存成功");
                } else {
                    throw err;
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        /**
         * UI Control
         */
        hide() {
            this.$emit("hide");
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    console.log("error submit!!");
                    return false;
                }
                this.updateUser();
                this.form = Object.assign({}, defaultForm);
                this.hide();
            });
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.form = Object.assign({}, defaultForm, this.editing);
            } else {
                this.form = Object.assign({}, defaultForm);
            }
        }
    },
    mounted() {}
};
</script>
